import {scaleLinear, scaleOrdinal, scaleBand, scalePoint} from 'd3-scale'
import {line, area} from 'd3-shape'
import {axisBottom, axisLeft} from 'd3-axis'
import {select, selectAll} from 'd3-selection'
import {schemeCategory10} from 'd3-scale-chromatic'
import {hierarchy, treemap, pack} from 'd3-hierarchy'
import {transition} from 'd3-transition'
import {extent} from 'd3-array'

export default {
  scaleLinear: scaleLinear,
  scaleOrdinal: scaleOrdinal,
  scaleBand: scaleBand,
  scalePoint: scalePoint,
  schemeCategory10: schemeCategory10,
  hierarchy: hierarchy,
  pack: pack,
  treemap: treemap,
  axisBottom: axisBottom,
  axisLeft: axisLeft,
  transition: transition,
  select: select,
  selectAll: selectAll,
  line: line,
  area: area,
  extent: extent,
}
